import { render, staticRenderFns } from "./qScripts.vue?vue&type=template&id=1580e764&"
import script from "./qScripts.vue?vue&type=script&lang=ts&"
export * from "./qScripts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports